// Dynamic banner height adjustment based on mini slider content
function adjustBannerHeight() {
    const banner = document.querySelector('.page-banner-block.home-banner');
    const miniSlider = document.querySelector('.mini-slider');
    
    if (!banner || !miniSlider) return;
    
    // Only adjust on screens where mini slider overlays the banner
    if (window.innerWidth < 768) return; // Mobile breakpoint where mini slider is below
    
    // Reset to auto to measure natural height
    banner.style.height = 'auto';
    
    // Measure mini slider height
    const miniSliderHeight = miniSlider.offsetHeight;
    const miniSliderTop = miniSlider.offsetTop;
    
    // Calculate required banner height
    // Mini slider bottom position + reasonable gap (120px)
    const requiredHeight = miniSliderTop + miniSliderHeight + 120;
    
    // Set minimum height to original 750px, but expand if needed
    const finalHeight = Math.max(750, requiredHeight);
    
    banner.style.height = `${finalHeight}px`;
}

// Run on load and resize
document.addEventListener('DOMContentLoaded', adjustBannerHeight);
window.addEventListener('resize', adjustBannerHeight);

// Run after mini slider is initialized (small delay to ensure content is rendered)
setTimeout(adjustBannerHeight, 100);